module.exports = __webpack_public_path__ + "static/img/Mira.50e2408.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mira.jpg
// module id = HpSS
// module chunks = 1